import { clearSection }                 from 'dmpconnectjsapp-base/actions';
import commands                         from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections }                  from 'dmpconnectjsapp-base/constants';
import { hasError, isLoading, isReady } from 'dmpconnectjsapp-base/helpers/common';
import * as PropTypes                   from 'prop-types';
import React                            from 'react';
import { AsyncTypeahead }               from 'react-bootstrap-typeahead';
import { connect }                      from 'react-redux';
import { getAction }                    from '../../dmpconnect/actions';

const CisCodeAsyncTypeAhead = ({
  dispatch,
  selectedCodes,
  onChange,
  getCisCodesSection,
  isInvalid,
  multiple,
  id,
  name,
  selectionRule,
  disabled
}) => {
  const ref                 = React.useRef();
  const [search, setSearch] = React.useState();
  const [searchInitialized, setSearchInitialized] = React.useState(false);
  
  React.useEffect(() => {
    if (!search && selectedCodes && selectedCodes.length === 1 && !searchInitialized) {
      setSearchInitialized(true);
      setSearch(selectedCodes[0].name.substring(0, 10));
    }
  }, [selectedCodes, searchInitialized]);
  
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (search) {
        dispatch(clearSection(apiSections.CIS_CODES));
        dispatch(getAction(
          commands.getCisCodes,
          apiSections.CIS_CODES,
          { s_name: `${search}%` },
        ));
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [search]);
  
  const list = React.useMemo(() => {
    if (isReady(getCisCodesSection)) {
      const array = getCisCodesSection.Codes;
      return array
      .filter(code => code.s_atcCode.startsWith("J07"))
      .map(code => ({
        name      : code.s_name,
        cisCode   : code.s_code,
        atcCode   : code.s_atcCode,
        isMarketed: code.i_marketed
      }));
    } else if (hasError(getCisCodesSection)) {
      return [];
    }
    return [];
  }, [getCisCodesSection]);
  
  return (
    <>
      <AsyncTypeahead
        clearButton
        useCache={false}
        inputProps={{ className: 'form-control-sm' }}
        className="custom-typeahead"
        ref={ref}
        id={id}
        isLoading={isLoading(getCisCodesSection)}
        labelKey="name"
        minLength={1}
        onSearch={(query) => setSearch(query)}
        selected={list.filter(cis => selectedCodes.some(sc => sc.cisCode === cis.cisCode))}
        options={list}
        placeholder="Rechercher un produit ..."
        searchText="Recherche en cours ..."
        emptyLabel="Aucun résultat"
        multiple={multiple}
        isInvalid={isInvalid}
        onChange={selection => {
          if (!!selection) {
            onChange({
              target: {
                value: multiple ? selection : selection[0],
                name,
              }
            });
          } else {
            onChange({
              target: {
                value: {},
                name,
              }
            });
          }
        }}
        renderMenuItemChildren={(option, { text }, index) => (
          <div className="d-flex flex-column mss-recipients">
            <div className="d-flex align-items-center mss-recipient-name">
              {option.name}
            </div>
            {option.isMarketed === 0 && (
              <div className="d-flex align-items-center mss-recipient-idNat">
                <small className="text-danger">
                  Non commercialisé
                </small>
              </div>
            )}
          </div>
        )}
        disabled={disabled}
      />
    </>
  );
};

function mapStateToProps(state) {
  const
    {
      dmpconnect: {
        [apiSections.CIS_CODES]: getCisCodesSection,
      },
    } = state;
  
  return {
    getCisCodesSection,
  };
}

CisCodeAsyncTypeAhead.propTypes = {
  dispatch          : PropTypes.func.isRequired,
  selectedCodes     : PropTypes.array,
  onChange          : PropTypes.func.isRequired,
  getCisCodesSection: PropTypes.object,
  isInvalid         : PropTypes.bool,
  multiple          : PropTypes.bool,
  disabled          : PropTypes.bool,
  labelKey          : PropTypes.string,
  id                : PropTypes.string.isRequired,
  name              : PropTypes.string.isRequired,
};

CisCodeAsyncTypeAhead.defaultProps = {
  selectedCodes     : [],
  getCisCodesSection: {},
  isInvalid         : false,
  labelKey          : 's_name',
  multiple          : false,
  disabled          : false,
};

export default connect(mapStateToProps)(CisCodeAsyncTypeAhead);
